import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getPresentationSelectorsState } from './store/presentation.selectors';
import { setPresentationAction } from './store/presentation.actions';
import { IframeSlideComponent } from './iframe-slide/iframe-slide.component';
import { FormsService } from 'src/app/services/forms.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
})
export class PresentationComponent implements OnInit {
  @ViewChild('meuIframe') meuIframe: ElementRef;

  iframeVisivel: boolean = false;
  isIframe = false;
  studyId: number = 0;
  token: string = '';
  formsId: number = 0;
  
  check$: Observable<any>;
  
  constructor(
    public dialog: MatDialog,
    private store: Store,
    private readonly formsService: FormsService
  ) {}

  ngOnInit(): void {
    this.fetchFormsData();
  }

  ativarModoTelaCheia() {
    this.iframeVisivel = true;
    const iframeElement = this.meuIframe.nativeElement;
    if (iframeElement.requestFullscreen) {
      iframeElement.requestFullscreen();
    } else if (iframeElement.mozRequestFullScreen) {
      iframeElement.mozRequestFullScreen();
    } else if (iframeElement.webkitRequestFullscreen) {
      iframeElement.webkitRequestFullscreen();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(IframeSlideComponent, {
      panelClass: 'iframe-dialog',
    });
    dialogRef.afterClosed().subscribe();
  }

  goToVideo(){
    this.isIframe = true
  }

  validateStatePage(): void {
    this.setStates(true);
    this.getStates();
  }

  setStates(check: boolean) {
    this.store.dispatch(setPresentationAction({ check }));
  }

  getStates() {
    this.check$ = this.store.select(getPresentationSelectorsState);

    // Assine ao Observable para obter o valor do seletor
    this.check$.subscribe((value) => {});
  }

  fetchFormsData() {
    this.formsId = Number(getCookie('formsId'));
    this.studyId = Number(getCookie('studyId'));
    this.token = getCookie('token');
    this.formsService.getForm(this.studyId).subscribe((res: any) => {
      localStorage.setItem('formsId', res.id);
      document.cookie = `formsId=${res.id}; path=/; domain=.techfinance.com.br`;
    });
  }
}
